module.exports = __webpack_public_path__ + "img/eye.bf058e32.svg";